import { isMarketingPath } from './webPaths';

type Listener = (pathname: string) => void;

let currentPath =
  typeof window !== 'undefined' ? window.location.pathname : '/';
const listeners = new Set<Listener>();

export function getWebPathname(): string {
  if (typeof window !== 'undefined') {
    return window.location.pathname;
  }
  return currentPath;
}

export function publishWebPathname(pathname?: string): void {
  const next = pathname ?? getWebPathname();
  if (next === currentPath) return;
  currentPath = next;
  listeners.forEach((listener) => listener(currentPath));
}

export function subscribeWebPathname(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function isMarketingWebRoute(pathname = getWebPathname()): boolean {
  return isMarketingPath(pathname);
}
